"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  WYSIWYG: true,
  WYSIWYGEditorState: true
};
exports.WYSIWYG = void 0;
Object.defineProperty(exports, "WYSIWYGEditorState", {
  enumerable: true,
  get: function get() {
    return _draftJs.EditorState;
  }
});
var _react = _interopRequireWildcard(require("react"));
var _draftJs = require("draft-js");
var _reactDraftWysiwyg = require("react-draft-wysiwyg");
var _images = _interopRequireDefault(require("./images"));
var _misc = require("./misc");
Object.keys(_misc).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _misc[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _misc[key];
    }
  });
});
var _ImageDecorator = _interopRequireDefault(require("./ImageDecorator"));
var _WarningMessage = require("./WarningMessage");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var iconClassName = 'editor-toolbar-icon';
var popupClassName = 'editor-popup';
var defaultOptions = {
  options: ['inline', 'list', 'link', 'emoji'],
  inline: {
    options: ['bold', 'italic' /*'underline' AWS doesn't support underline that isn't a hyperlink*/],
    bold: {
      icon: _images.default.Bold,
      className: iconClassName
    },
    italic: {
      icon: _images.default.Italic,
      className: iconClassName
    },
    underline: {
      icon: _images.default.Underline,
      className: iconClassName
    }
  },
  list: {
    options: ['unordered', 'ordered'],
    unordered: {
      icon: _images.default.Unordered
    },
    ordered: {
      icon: _images.default.Ordered
    }
  },
  emoji: {
    icon: _images.default.Emoji,
    className: iconClassName,
    emojis: _misc.emojis,
    popupClassName: popupClassName
  },
  link: {
    className: iconClassName,
    defaultTargetOption: '_blank',
    link: {
      icon: _images.default.Hyperlink
    },
    options: ['link'],
    popupClassName: popupClassName
  }
};
var WYSIWYG = function WYSIWYG(_ref) {
  var editorState = _ref.editorState,
    onEditorStateChange = _ref.onEditorStateChange,
    label = _ref.label,
    required = _ref.required,
    options = _ref.options,
    toolbarButtons = _ref.toolbarButtons,
    placeholder = _ref.placeholder,
    enableQuickReplies = _ref.enableQuickReplies,
    handleKeyCommand = _ref.handleKeyCommand,
    quickRepliesComponent = _ref.quickRepliesComponent,
    files = _ref.files,
    onDeleteFile = _ref.onDeleteFile,
    isShowWarningMessage = _ref.isShowWarningMessage,
    setIsShowWarningMessage = _ref.setIsShowWarningMessage,
    keyBindingFn = _ref.keyBindingFn,
    handleReturn = _ref.handleReturn,
    wrapperClassName = _ref.wrapperClassName,
    editorClassName = _ref.editorClassName,
    toolbarClassName = _ref.toolbarClassName,
    wysiwygClassName = _ref.wysiwygClassName,
    defaultOptionsToUse = _ref.defaultOptionsToUse;
  // 😬
  document.querySelectorAll('.public-DraftEditor-content').forEach(function (item) {
    item.setAttribute('data-noShortcut', 'true');
  });
  if (enableQuickReplies && quickRepliesComponent) {
    toolbarButtons === null || toolbarButtons === void 0 ? void 0 : toolbarButtons.push(quickRepliesComponent);
  }
  var defaultKeyBindingFn = function defaultKeyBindingFn(e) {
    if (e.keyCode === 13 && e.shiftKey) {
      return 'sa-editor-send';
    }
    return (0, _draftJs.getDefaultKeyBinding)(e);
  };
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      var _document$getElements, _document$getElements2, _document$getElements3;
      (_document$getElements = document.getElementsByClassName('sa-wysiwyg-toolbar')) === null || _document$getElements === void 0 ? void 0 : _document$getElements[0].setAttribute('tabindex', '0');
      // document.getElementsByClassName('sa-wysiwyg-toolbar__quick-replies')[0].setAttribute('tabindex', '0')
      (_document$getElements2 = document.getElementsByClassName('sa-wysiwyg-send')) === null || _document$getElements2 === void 0 ? void 0 : (_document$getElements3 = _document$getElements2[0]) === null || _document$getElements3 === void 0 ? void 0 : _document$getElements3.setAttribute('tabindex', '0');
      var buttons = document.getElementsByClassName('rdw-option-wrapper');
      for (var _i = 0; _i < buttons.length; _i++) {
        buttons[_i].setAttribute('tabindex', '0');
      }
      var buttons2 = document.getElementsByClassName('rdw-inline-wrapper');
      for (var _i2 = 0; _i2 < buttons2.length; _i2++) {
        buttons2[_i2].setAttribute('tabindex', '0');
      }
    }, 150);
  }, []);
  (0, _react.useEffect)(function () {
    var stringToInsert = files !== null && files !== void 0 && files.length ? '@SA_IMAGE' + files.map(function (f) {
      var type = f.file.type.replace('vnd.openxmlformats-officedocument.wordprocessingml.document', 'doc').replace('msword', 'doc').replace('vnd.ms-powerpoint', 'ppt').replace('vnd.openxmlformats-officedocument.presentationml.presentation', 'ppt').replace('vnd.ms-excel', 'xls').replace('vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'xls');
      return "[".concat(f.file.name, "~").concat(type, "~").concat(f.loadingState, "~").concat(f.file.type.split('/')[0] === 'image' ? getObjectUrl(f.file) : 'null', "]");
    }).join('') : '';
    var newEditorState = insertText("\n".concat(stringToInsert), editorState);
    onEditorStateChange(newEditorState);
    setTimeout(function () {
      var _document$getElements4;
      (_document$getElements4 = document.getElementsByClassName('DraftEditor-root')[0]) === null || _document$getElements4 === void 0 ? void 0 : _document$getElements4.click();
    }, 100);
  }, [files]);
  var insertText = function insertText(text, editorState) {
    var currentContent = editorState.getCurrentContent(),
      currentSelection = editorState.getSelection();
    var newContent = _draftJs.Modifier.replaceText(currentContent, currentSelection, text);
    var newEditorState = _draftJs.EditorState.push(editorState, newContent, 'insert-characters');
    return _draftJs.EditorState.forceSelection(newEditorState, newContent.getSelectionAfter());
  };
  var decorators = (0, _react.useMemo)(function () {
    var decorators = [];

    // files
    if (files && onDeleteFile) {
      decorators.push((0, _ImageDecorator.default)({
        onDeleteFile: onDeleteFile,
        editorState: editorState
      }));
    }
    return decorators;
  }, [files, onDeleteFile]);
  function getDefaultOptions(defaultOptionsToUse) {
    if (!defaultOptionsToUse || !defaultOptionsToUse.length) return defaultOptions;
    var requiredOptions = defaultOptionsToUse.reduce(function (opts, key) {
      return _objectSpread(_objectSpread({}, opts), {}, _defineProperty({}, key, defaultOptions[key]));
    }, {});
    requiredOptions.options = defaultOptionsToUse;
    return requiredOptions;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('sa-wysiwyg', wysiwygClassName),
    onDragOver: function onDragOver(e) {
      console.log('drag-over');
    }
  }, isShowWarningMessage && setIsShowWarningMessage && /*#__PURE__*/_react.default.createElement(_WarningMessage.WarningMessage, {
    setIsShowWarningMessage: setIsShowWarningMessage
  }), label && /*#__PURE__*/_react.default.createElement("div", {
    className: "sa-wysiwyg-label"
  }, /*#__PURE__*/_react.default.createElement("label", null, label, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, required ? '*' : ''))), /*#__PURE__*/_react.default.createElement(_reactDraftWysiwyg.Editor, {
    spellCheck: true,
    editorState: editorState,
    onEditorStateChange: onEditorStateChange,
    wrapperClassName: (0, _classnames.default)('sa-wysiwyg-wrapper', wrapperClassName),
    editorClassName: (0, _classnames.default)('sa-wysiwyg-editor', editorClassName),
    toolbarClassName: (0, _classnames.default)('sa-wysiwyg-toolbar', toolbarClassName),
    customDecorators: decorators,
    toolbarCustomButtons: toolbarButtons,
    placeholder: placeholder,
    toolbar: _objectSpread(_objectSpread({}, getDefaultOptions(defaultOptionsToUse)), options)
    //@ts-ignore
    ,
    handleKeyCommand: handleKeyCommand,
    keyBindingFn: keyBindingFn !== null && keyBindingFn !== void 0 ? keyBindingFn : defaultKeyBindingFn,
    handleReturn: handleReturn
  }));
};
exports.WYSIWYG = WYSIWYG;
var getObjectUrl = function getObjectUrl(file) {
  return window.URL.createObjectURL(file);
};